import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { ToastContainer } from 'react-toastify'

import * as actions from '../../actions'
import {
  ReimpresionComprobanteDescarga0
} from './steps'
import { FORM_REIMPRESION_COMPROBANTE } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'

const selector = formValueSelector(FORM_REIMPRESION_COMPROBANTE)

class ReimpresionComprobanteDescarga extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit () {
    this.props.verificarYReimprimirTicketDescarga(this.props.numero, this.props.descargaImpresora.trim())
    this.props.destroy()
  }

  render () {
    const {
      reimpresionStep
    } = this.props

    return (
      <div className='camiones-ingreso-completo-container'>
        <h2>Reimpresión de Comprobante de Descarga</h2>
        {reimpresionStep === 0 && <ReimpresionComprobanteDescarga0 onSubmit={this.handleSubmit} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reimpresionStep: state.camionesIngreso.reimpresionStep,
    numero: selector(state, 'numero'),
    descargaImpresora: state.pesado.printerComprobanteDescarga
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({
    form: FORM_REIMPRESION_COMPROBANTE
  })(ReimpresionComprobanteDescarga)
)
